export default __webpack_public_path__ + "static/media/NELLA.a1f865d8.svg";